import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { handleV3Redirect } from '../';
import { NEW_APP_URL } from '../config';
import { UPDATE_PROFILE_INFO } from '../constants/endpoints';
import { OptedWorkspaceExperience } from '../interfaces/currentUser';
import { makeAPICall } from '../queries/utils';
import useLayoutStore from '../stores/layoutStore';
import mobileStore from '../stores/mobileAppStore';
import { isMobilePlatform } from '../Utils/window';

export async function useEnforceV3Experience({
  shortCode,
  slugUrl,
  shouldEnforceV3Experience,
}: {
  shortCode: string | undefined;
  slugUrl: string;
  shouldEnforceV3Experience: boolean;
}) {
  const { isEmbeddedInMainApp } = useLayoutStore();
  const { pathname } = useLocation();
  const isMobileApp =
    isMobilePlatform &&
    (mobileStore.getState().isMobileApp ||
      new URLSearchParams(location.search).get('isMobileApp') === 'true');

  const enforceV3Experience = useCallback(async () => {
    if (
      !(
        pathname.match(/\/(signin|bot)\/authorize/g) ||
        pathname.startsWith('/slack-redirect') ||
        pathname.startsWith('/security/') ||
        pathname.startsWith('/auth/saml') ||
        pathname.startsWith('/template/')
      )
    ) {
      if (!shortCode || pathname.includes('/home')) {
        await makeAPICall(UPDATE_PROFILE_INFO, {
          optedWorkspaceType: OptedWorkspaceExperience.New,
        });
        window.location.href = `${NEW_APP_URL}/discover`;
      } else if (!isEmbeddedInMainApp) {
        await makeAPICall(UPDATE_PROFILE_INFO, {
          optedWorkspaceType: OptedWorkspaceExperience.New,
        });
        await handleV3Redirect({
          shortCode,
          slugPath: slugUrl,
        });
      }
    }
  }, [isEmbeddedInMainApp, shortCode, slugUrl, pathname]);

  useEffect(() => {
    if (shouldEnforceV3Experience && !isMobileApp) {
      enforceV3Experience();
    }
  }, [enforceV3Experience, isMobileApp, shouldEnforceV3Experience]);
}
